import React from 'react';

function ResultsRowFallback() {
    return (
        <tr>
            <td colSpan={6} className="text-center">
                Sorry, we encountered an error on this row.
            </td>
        </tr>
    );
}

export { ResultsRowFallback };
